import { Checkbox as MuiCheckbox, styled } from '@material-ui/core';

export const Checkbox = styled(MuiCheckbox)({
  marginRight: '12px',
  padding: 0,
});
